import React from 'react';
import Nurse from '../Nurse/Nurse';

function Doctor() {
    return <Nurse healthcareType="doctor" />;
}

export default Doctor;
